/**
 * Linear-interpolation quantile (type 7) on a pre-sorted ascending array.
 * `q` in [0, 1]; the array must be non-empty.
 */
export function quantileFromSorted(
  sorted: readonly number[],
  q: number,
): number {
  const pos = q * (sorted.length - 1)
  const lo = Math.floor(pos)
  const hi = Math.ceil(pos)
  return lo === hi
    ? sorted[lo]
    : sorted[lo] + (pos - lo) * (sorted[hi] - sorted[lo])
}
